import { Panel, PanelHeaderTemplateOptions } from "primereact/panel";
import { useTranslation } from "react-i18next";
import "./styles.css";
 
export default function AnaliseSetorial({ analises }: { analises: any }) {
  const { t } = useTranslation();
  const regex = /\d+(?:\.\d+)?(?:\s*a\s*\d+)?%?/g;
  const title = analises?.[0];
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
     return  <div className={className}><span><svg width="24" height="24" viewBox="0 0 24 24" style={{stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><path d="M12 16v5"/><path d="M16 14v7"/><path d="M20 10v11"/><path d="m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15"/><path d="M4 18v3"/><path d="M8 14v7"/></svg><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('analises')}</span></span> </div>;
  } 
  const [valueNum01, valueNum02, valuePercent] = analises?.[2]?.match(regex);
  const [quantityNum01, quantityPercent] = analises?.[3]?.match(regex);
  const indice = analises.indexOf('Operações em Aberto do Setor - Valores em Reais (12 meses)')
  const value2 = analises?.[indice+1]?.replace("> 5 dias < 360", "")?.match(regex);
  const quantity2 = analises?.[indice+2]?.replace("> 5 dias < 360", "")?.match(regex);

  const percentA = !valuePercent ? 0 :
    (Number(valuePercent.replace("%", "")) +
      Number(quantityPercent.replace("%", ""))) /
    2;
 
  const percentB = quantity2 ?
    (Number(quantity2[3]?.replace("%", "")) +
      Number(value2[value2.length - 1].replace("%", ""))) /
    2 : 0;
 
  return (
    <Panel
      headerTemplate={headerTemplate}
      className="content-width"
      toggleable
    >
      <div>
        {title && <p className="analise-title">{title}</p>}
        <p className="analise-title">{analises[1]}</p>
        <div className="grid-setorial">
          <p>Valor total Médio Operações liquidadas Pontualmente</p>
          <p>
            R${valueNum01} a R${valueNum02}
          </p>
          <p>% de valores pagos pontualmente (a)</p>
          <p>{quantityPercent}</p>
          <p>Pontualidade Média (a+b/2)</p>
        </div>
        <div className="grid-setorial">
          <p>Quantidade total Médio Operações Liquidadas Pontualmente</p>
          <p>{quantityNum01}</p>
          <p>% da quantiade de operações pagas pontualmente (b)</p>
          <p>{valuePercent ?? 0}</p>
          <p>{percentA.toFixed(2)}%</p>
        </div>
        <div className="analise-title" style={{ background: "transparent" }}>
            <div className="grid">
                <div className="col"><p>{analises[4].split('.')[0]}</p></div>
                <div className="col"><p>{analises[4].split('setor.')[1]}</p></div>
            
            </div>
        </div>
        <div className="analise-title" style={{ background: "transparent" }}>
            <p><b>Fontes consultadas: </b> {analises[5].split('.')[0]}</p>
        </div>
      </div>
      <br />
      {value2 && (
      <div>
        <p className="analise-title">{analises[indice]}</p>
 
        <div className="grid-setorial">
          <p>
            Valor total Médio Operações <br /> vencidas {">"} 5dias e {"<"} 360
            Dias
          </p>
          <p>
            R${value2[2]} a R${value2[3]}
          </p>
          <p>
            Valor Operações Vencidas {">"} 5 dias {"<"} 360 dias (a)
          </p>
          <p>{quantity2[quantity2.length - 1]}</p>
          <p>Pontualidade Média (a+b/2)</p>
        </div>
        <div className="grid-setorial">
          <p>
            Quantidade total Médio Operações <br /> vencidas {">"} 5dias e {"<"}{" "}
            360 Dias
          </p>
          <p>{quantity2[2]}</p>
          <p>
            Quantidade Operações Vencidas {">"} 5 dias {"<"} 360 dias (b)
          </p>
          
          <p>{value2[value2.length - 1]}</p>
          <p>{percentB ? percentB.toFixed(2) : ''}%</p>
        </div>
        <div className="analise-title" style={{ background: "transparent" }}>
            <p><b>Fontes consultadas: </b> {analises[indice+3].split('.')[0]}</p>
        </div>
      </div>
      )}
      <br />
    </Panel>
  );
}